function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Shopping"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#e28d40",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M35,18.5l-1-7c-.8-3.866-4.169-8-8-8-2.873,0-5,2-5,7l1,8"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#ffb450",
  points: "4 47 8 12 20 13 32 12 37 47 4 47"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#e28d40",
  points: "41.5 41.375 37 47 32 12 36.5 14.25 41.5 41.375"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 17,
  r: 2,
  fill: "#fff3f7"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 17,
  r: 2,
  fill: "#fff3f7"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#ed9a40",
  points: "47 44 41 42 36 14 39 12 47 44"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#ed9a40",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M14,17l1-7c.8-3.866,4.169-8,8-8,2.873,0,5,2,5,7l-1,8"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#ffb450",
  points: "37 47 47 44 41 42 37 47"
}));

var SvgShoppingBag = function SvgShoppingBag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShoppingBag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopping-bag.d5aef198.svg";
export { ForwardRef as ReactComponent };